<template>
  <div>
    <span class="criterio-subtitle">{{ label }}</span>
    <v-tooltip v-if="tooltip" right max-width="350px">
      <template v-slot:activator="{ on }">
        <span v-on="on">
          <mf-icon small color="cinza-0">info</mf-icon>
        </span>
      </template>
      <span>{{ tooltip }}</span>
    </v-tooltip>
    <v-row>
      <v-col class="pt-0">
        <v-checkbox
          v-for="value in componentParams.checkboxValues"
          :key="value.id"
          v-model="selected"
          :label="value.label"
          :value="value.value || value.id"
          :disabled="disabled"
          hide-details
          @change="input"
        >
          <template v-slot:label>
            <span>
              {{ value.label }}
              <v-tooltip v-if="value.tooltip" right max-width="350px">
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    <mf-icon small color="cinza-0" class="ml-1">info</mf-icon>
                  </span>
                </template>
                <span>{{ value.tooltip }}</span>
              </v-tooltip>
            </span>
          </template>
        </v-checkbox>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'CriterioCheckbox',
  props: {
    values: {
      type: [Object, Array],
      required: false,
    },
    label: {
      type: String,
      required: false,
    },
    currentIndex: {
      type: Number,
      required: true,
    },
    initialValue: {
      type: [Object, Array, Number],
      required: false,
    },
    tooltip: {
      type: String,
      required: false,
    },
    componentParams: {
      type: Object,
      default: () => ({}),
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    selected: [],
  }),

  computed: {
    defaultSelected() {
      if (this.componentParams?.defaultAll) {
        return this.componentParams.checkboxValues.map((value) => value.value || value.id)
      }
      return []
    },
  },

  mounted() {
    if (this.initialValue) {
      this.selected = this.initialValue
    } else {
      this.selected = this.defaultSelected
      this.input(this.selected)
    }
    this.validate()
  },

  methods: {
    input(value) {
      this.$emit('input', { currentValue: value, currentIndex: this.currentIndex })
      this.validate()
    },

    validate() {
      this.$emit('validate', { isValid: this.isValid(), currentIndex: this.currentIndex })
    },

    isValid() {
      return Boolean(this.selected?.length)
    },
  },
}
</script>

<style lang="scss">
.criterio-radio-button {
  .v-input {
    margin-top: 0;
  }
}
</style>
